module.exports = __webpack_public_path__ + "static/img/slogan.5ef1e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/slogan.png
// module id = ELWo
// module chunks = 1 3